import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { OrderPreviewComponent } from '../order-preview/order-preview-component';
import { Order } from 'projects/reg-hub-common/src/public-api';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'lib-registration-order-preview',
    templateUrl: './registration-order-preview.component.html',
    styleUrls: ['./registration-order-preview.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RegistrationOrderPreviewComponent extends OrderPreviewComponent {
  private readonly transloco = inject(TranslocoService);
  @Input() order!: Order;

  getTerm() {
    return this.order.lien?.isInfiniteTerm ? this.transloco.translate('registrationOrderPreview.infinity') : this.order.lien?.term;
  }
}
